import React, { ChangeEventHandler } from 'react';
import styles from './other-attachment-item.module.css';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import BlockIcon from '@mui/icons-material/Block';
import RadarIcon from '@mui/icons-material/Radar';
import { Tooltip } from '@mui/material';

interface Props {
  readonly filename: string;
  readonly description: string;
  readonly url: string;
  readonly amazonKey: string;
  readonly content: string;
  readonly isOnline: boolean;
  readonly onDescriptionChange?: ChangeEventHandler<HTMLTextAreaElement>;
  readonly onFileRemoveClick: React.MouseEventHandler;
  readonly onUploadClick?: React.MouseEventHandler;
  readonly amazonId: string;
  readonly handleDownloadClick: (amazonKey: string, filename: string) => void; // Handle independently
  readonly disabled: boolean;
  readonly VirusDetected?: boolean;
  readonly AVScanned?: boolean;
}

export class OtherAttachmentItem extends React.Component<Props> {
  render() {
    const attachIcon = () => {
      if (this.props.VirusDetected) {
        return (
          <div className={styles.file}>
            <Tooltip title="Virus detected">
              <div className={styles.imageContainer}>
                <CoronavirusIcon style={{ fontSize: '6rem', color: '#842200' }} />
              </div>
            </Tooltip>  
              <div className={styles.filenameContainer}>
                <span className={styles.filename}>Virus</span>
              </div>
          </div>
        );
      } else {
        if (this.props.AVScanned === false) {
          // When false then this means that the file is not scanned yet
          // when true or null then the file is scanned or if null then it is an old upload
          return (
            <div className={styles.file}>
              <Tooltip title="AV Scanning">
                <div className={styles.imageContainer}>
                  <RadarIcon style={{ fontSize: '5rem', color: '#842200' }} />
                </div>
              </Tooltip>  
                <div className={styles.filenameContainer}>
                  <span className={styles.filename}>Scanning</span>
                </div>
            </div>
          );
        } else {
          return (
            <div
              className={styles.file}
              onClick={() =>
                this.props.handleDownloadClick(this.props.amazonKey, this.props.filename)
              }
            >
              <div className={styles.imageContainer}>
                <img
                  className={styles.image}
                  src={require('../../../../assets/images/file55x69.png')}
                  alt=""
                />
              </div>
              <div className={styles.filenameContainer}>
                <span className={styles.filename}>{this.props.filename}</span>
              </div>
            </div>
          );
        }
      }
    }

    return (
      <div className={styles.container}>
        <div className={styles.actions}>
          {attachIcon()}
          <div className={styles.fileActions}>
            {!this.props.disabled && this.props.AVScanned !== false && (
              <div className={styles.fileRemove} onClick={this.props.onFileRemoveClick}>
                <img
                  className={styles.actionIcon}
                  src={require('../../../../assets/images/remove_85x85.png')}
                  alt=""
                />
              </div>
            )}
            {(this.props.disabled || this.props.AVScanned === false) && (
              <div className={styles.noFileActions}>
                <BlockIcon className={styles.img} style={{ fontSize: '4rem', color: '#84a1d4' }} />
              </div>
            )}
            {this.fileUploadElement}
          </div>
        </div>
        <div className={styles.description}>
          <textarea
            className={styles.descriptionText}
            {...this.textAreaProps}
            onChange={this.props.onDescriptionChange}
            disabled={this.props.isOnline}
          />
        </div>
      </div>
    );
  }

  private get textAreaProps() {
    return this.props.onDescriptionChange
      ? { value: this.props.description }
      : { defaultValue: this.props.description };
  }

  private get fileUploadElement() {
    return this.props.isOnline ? (
      <div className={styles.fileUpload}></div>
    ) : (
      <div className={styles.fileUpload} onClick={this.props.onUploadClick}>
        <img
          className={styles.actionIcon}
          src={require('../../../../assets/images/save_85x85.png')}
          alt=""
        />
      </div>
    );
  }
}
